module.exports = __webpack_public_path__ + "img/img1_2.b545b85e.jpeg";